import React, { Component, useState, useEffect, useRef } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';

import $ from 'jquery';
import Cookies from 'js-cookie';
import Col from 'react-bootstrap/Col';

export const user_session_id = 'user';
export const shopping_cart_session_id = 'shoppingcart';
export const days = 8 / 24;
export const shopping_cart_session_days = days;

export const BackToKdealerLogin = () => {
    if (window.location.origin.indexOf("dev-kdealer") > -1 || window.location.origin.indexOf("sb-kdealer") > -1) {
        window.location.href = 'https://www.dev1-k-dealer.com';
    }
    else {
        window.location.href = 'https://www.k-dealer.com/';
    }
}
export const GetDomain = () => {
    console.log(window.location.origin);
    if (window.location.origin.indexOf("localhost") > -1) {
        return "";
    }
    else {
        return window.location.origin.replace('https://','');
    }
}
export const CheckSession = () => {
    const ck = GetCoockie();
    //console.log(ck);
    if (!ck) {
        window.location.href = '/login';
    }
}
export const FormatCurrency = (number) =>{
    return number.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    });
}
export const GetCoockie = () => {
    //let domain = GetDomain();
    let usr = Cookies.get(user_session_id);
    try {
        if (usr) {
            const jsonObject = JSON.parse(usr);
            return jsonObject;
        }
    }
    catch (e) {
        console.log(e);
    }
    
    return null;
    
}

export const ValidateQty = (val) => {
    try {
        if (val.length === 0) {
            throw new Error("empty.");
        }
        if (/^-?\d+$/.test(val) === false) {
            throw new Error("Only integer is allowed.");
        }
        const num = Number(val);
        if (num > 999 || num < 1) {
            debugger;
            if (num > 999 && val.trim().length > 3) {
                return val.substring(0,3);
            }
            else {
                throw new Error("Out of range.");
            }
           
        }
        else {
            return val;
        }
    }
    catch (e) {
        console.log(e);
        return '';
    }

}
export const RemoveCookie = (days,sessionId) => {
    let domain = GetDomain();
    if (domain === '') {
        Cookies.remove(sessionId, { expires: days });
    }
    else {
        Cookies.remove(sessionId, { expires: days, domain: domain });
    }

}

export const DefaultImage = "../../../Images/404.png";

export const GetShoppingCart =()=>{
    const sc = localStorage.getItem(shopping_cart_session_id);
    return sc ? JSON.parse(sc) : null;
}
export const UpdateShoppingCart = (obj) => {
    localStorage.setItem(shopping_cart_session_id, JSON.stringify(obj));
}
export const KImageURL = (sku, fileName) => {
    if (!sku || !fileName) {
        return "";
    }
    const newSKU = sku.replaceAll('-', '');
    return `https://www.kawasaki.com/content/uploads/accessories/${newSKU}/${fileName}`;
}
export const SearchContent = (key) => {
    const isSESOrder = IsSESOrderID(key);
    const isInvoiceID = IsInvoiceID(key);
    const isKMCOrderID = IsKMCOrderID(key);
    let str = '';
    if (isSESOrder) {
        str = 'Ref: #';
    }
    else if (isInvoiceID) {
        str = 'INVOICE: #';
    }
    else if (isKMCOrderID) {
        str = 'Order: #';
    }
    else {
        str = 'Item: #';
    }
    str += key;
    return (
        <Col sm={12} key={"col1_" + key}>
            <h5 className="heading green-text text-left mt-2">{str}</h5>
        </Col>
    );
}
const IsSESOrderID = (val) => {
    return val.startsWith('KDL') || val.startsWith('KCN');
}
const IsInvoiceID = (val) => {
    return val.startsWith('P00');
}
const IsKMCOrderID = (val) => {
    return val.startsWith('0000');
}

